import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
  constructor() {
    this.init();
  }

  init() {
    this.setScrollTrigger();
    this.smoothScroll();
  }

  setScrollTrigger() {
    const revealElm = [...document.querySelectorAll(".js-scrollreveal")];

    revealElm.forEach((el) => {
      ScrollTrigger.create({
        trigger: el,
        start: "top 85%",
        //markers: true,
        onEnter: () => {
          el.setAttribute("data-reveal", "1");
        },
      });
    });
  }

  smoothScroll() {
    const triggers = [...document.querySelectorAll(".js-smoothscroll")];
    const pagetop = [...document.querySelectorAll(".js-pagetop")];

    triggers.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        const hash = el.getAttribute("href");
        const offset = 0;
        gsap.to(window, {
          duration: 1,
          scrollTo: { y: hash, offsetY: offset },
          ease: "circ.inOut",
        });
      });
    });

    pagetop.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        gsap.to(window, {
          duration: 1,
          scrollTo: { y: 0 },
          ease: "circ.inOut",
        });
      });
    });
  }
}
